module.exports = __webpack_public_path__ + "img/share2.6f4b6101.6f4b6101.svg";